/* unplugin-vue-components disabled */import script from "./ExplainView.vue?vue&type=script&setup=true&lang=js"
export * from "./ExplainView.vue?vue&type=script&setup=true&lang=js"

import "./ExplainView.vue?vue&type=style&index=0&id=d10a908a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d10a908a"]])

export default __exports__